export default __webpack_public_path__ + "static/media/pdf.ed6324ea.svg";